import Baroni1 from '../../../media/Residentials/Baroni/Baroni.webp'
import Baroni2 from '../../../media/Residentials/Baroni/Baroni (2).webp'
import Baroni3 from '../../../media/Residentials/Baroni/Baroni (3).webp'
import Baroni4 from '../../../media/Residentials/Baroni/Baroni (4).webp'
import Baroni5 from '../../../media/Residentials/Baroni/Baroni (5).webp'
import Baroni6 from '../../../media/Residentials/Baroni/Baroni (6).webp'
import Baroni7 from '../../../media/Residentials/Baroni/Baroni (7).webp'
import Baroni8 from '../../../media/Residentials/Baroni/Baroni (8).webp'
import Baroni9 from '../../../media/Residentials/Baroni/Baroni (9).webp'


const Baroniimages =[
Baroni1,Baroni2,Baroni3,Baroni4,Baroni5,Baroni6,Baroni7,Baroni8,Baroni9
]

export default Baroniimages;